<template>
  <v-container py-0>
    <og-table>
      <og-table-head>
        <tr>
          <th>{{ $t('Tipo de documento') }}</th>
          <th class="pa-0 text-xs-center" v-for="(month, i) in months" :key="i">
            {{ month.label }}
          </th>
        </tr>
      </og-table-head>

      <og-table-body v-if="documentsReady">
        <tr v-for="type in documentTypes" :key="type.value">
          <td class="width-td-40">{{ $t(type.label) }}</td>
          <td class="pa-0 text-xs-center" v-for="month in months" :key="month.number">
            <template v-if="documents[type.value][year + '-' + month.number]">
              <v-btn
                v-if="documents[type.value][year + '-' + month.number].length === 1"
                @click="downloadEntity(documents[type.value][year + '-' + month.number][0])"
                color="primary"
                icon
                flat
              >
                <v-icon>mdi-file-document-outline</v-icon>
              </v-btn>
              <v-btn
                v-if="documents[type.value][year + '-' + month.number].length > 1"
                @click="multiDownload(documents[type.value][year + '-' + month.number])"
                color="primary"
                icon
                flat
              >
                <v-icon>mdi-package-variant-closed</v-icon>
              </v-btn>
            </template>
          </td>
        </tr>
      </og-table-body>

      <template v-else>
        <tr>
          <td colspan="13">
            <div class="py-5 text-xs-center big-loading-table">
              <v-progress-circular size="100" color="primary" indeterminate></v-progress-circular>
            </div>
          </td>
        </tr>
      </template>
    </og-table>
  </v-container>
</template>

<script>
import apiCtrl from '@/services/api/abstract/abstract-api.js';
import OgTable from '@/components/commons/OgTable.vue';
import OgTableBody from '@/components/commons/OgTableBody.vue';
import OgTableHead from '@/components/commons/OgTableHead.vue';
export default {
  components: {
    OgTable,
    OgTableBody,
    OgTableHead,
  },
  props: {
    year: {
      type: [String, Number],
    },
    category: {
      type: String,
      default: 'fiscal',
    },
  },
  data() {
    return {
      documentTypes: [],
      documentsReady: false,
      documents: {},
      currentMonth: 'OCT',
      months: [
        { number: '01', label: 'ENE' },
        { number: '02', label: 'FEB' },
        { number: '03', label: 'MAR' },
        { number: '04', label: 'ABR' },
        { number: '05', label: 'MAY' },
        { number: '06', label: 'JUN' },
        { number: '07', label: 'JUL' },
        { number: '08', label: 'AGO' },
        { number: '09', label: 'SEP' },
        { number: '10', label: 'OCT' },
        { number: '11', label: 'NOV' },
        { number: '12', label: 'DIC' },
      ],
      documentTypeLabels: {
        'MOD-100': 'Modelo 100. Renta y patrimonio: Declaración anual Renta.',
        'MOD-111':
          'Modelo 111. Retenciones e ingresos a cuenta. Rendimientos del trabajo y de actividades económicas.',
        'MOD-115':
          'Modelo 115. Retenciones e ingresos a cuenta. Rentas o rendimientos procedentes del arrendamiento de inmuebles urbanos.',
        'MOD-130': 'Modelo 130. IRPF. Pago fraccionado.',
        'MOD-180':
          'Modelo 180. Resumen anual IRPF. Retenciones e ingresos a cuenta. Rendimientos procedentes del arrendamiento de inmuebles urbanos.',
        'MOD-190':
          'Modelo 190. Resumen anual IRPF. Retenciones e ingresos a cuenta. Rendimientos del trabajo y de actividades económicas.',
        'MOD-200': 'Modelo 200. Impuesto de Sociedades.',
        'MOD-202': 'Modelo 202. Impuesto sobre Sociedades. Pago Fraccionado.',
        'MOD-303': 'Modelo 303. IVA. Autoliquidación.',
        'MOD-347':
          'Modelo 347. Declaraciones informativas: Declaración anual de operaciones con terceros.',
        'MOD-349': 'Modelo 349. Declaración Informativa. Operaciones intracomunitarias.',
        'MOD-390': 'Modelo 390. IVA. Declaración Resumen Anual.',
      },
    };
  },

  computed: {
    clavedat() {
      return this.$store.state.clavedat;
    },
  },
  mounted() {
    this.getDocuments();
  },
  watch: {
    year: function(val) {
      this.getUserObligations(this.clavedat, val);

      // console.log('new: %s, old: %s', val, oldVal)
    },
  },
  methods: {
    getDocuments() {
      this.documentsReady = false;
      const config = {
        params: {
          constraint: {
            'categories.name': this.category,
            month: this.year + '-:like',
          },
        },
      };

      apiCtrl.get('/consultant-document/clavedat/' + this.clavedat, config).then(res => {
        let types = {};
        this.documentTypes = [];
        res.data.data.forEach(doc => {
          if (!types.hasOwnProperty(doc.type)) {
            types[doc.type] = {
              label: this.documentTypeLabels[doc.type]
                ? this.documentTypeLabels[doc.type]
                : doc.type,
              value: doc.type,
            };
            this.documentTypes.push({
              label: this.documentTypeLabels[doc.type]
                ? this.documentTypeLabels[doc.type]
                : doc.type,
              value: doc.type,
            });
          }
        });

        this.documentTypes.forEach(docType => {
          res.data.data.forEach(doc => {
            if (!this.documents.hasOwnProperty(docType.value)) {
              this.documents[docType.value] = {};
            }

            if (doc.type === docType.value) {
              if (!this.documents[docType.value].hasOwnProperty(doc.month)) {
                this.documents[docType.value][doc.month] = [];
              }
              this.documents[doc.type][doc.month].push(doc);
            }
          });
        });

        console.log(this.documents);
        this.documentsReady = true;
      });
    },
    // testing wakatime again
    // and again
    // and again
    // and again
    downloadEntity(entity) {
      console.log(entity);
      if (entity.hasOwnProperty('media') && entity.media.length > 0) {
        apiCtrl
          .get('/document/download/' + entity.media[0].id)
          .then(res => {
            apiCtrl.downloadFile(res.data);
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    multiDownload(documents) {
      let ids = [];
      let name = '';
      documents.forEach(entity => {
        if (!name) {
          name = entity.type + '-' + entity.month;
        }
        if (entity.hasOwnProperty('media') && entity.media.length > 0) {
          entity.media.forEach(media => {
            ids.push(media.id);
          });
        }
      });

      return apiCtrl.downloadBlob('/document/multi-download', {
        params: { name: name, ids: ids },
      });
    },
  },
};
</script>
